import { render, staticRenderFns } from "./ApplicationRegist.vue?vue&type=template&id=0f625318"
import script from "./ApplicationRegist.vue?vue&type=script&lang=js"
export * from "./ApplicationRegist.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRegist.vue?vue&type=style&index=0&id=0f625318&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports